module.exports = __webpack_public_path__ + "img/image 34 (1).6fef5452.png";